var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"permanent":""}},[_c('div',{staticClass:"eds--layout"},[_c('MenuUsuario'),_c('div',{staticClass:"eds--layout-header-content"},[_c('HeaderUsuario'),_c('div',{staticClass:"eds--layout-content"},[_c('Nuxt')],1)],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }